<template>
  <div style="margin-bottom: -100px !important;">
    <van-nav-bar
      title="免费诊股"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/')"
    />
    <div class="rotatingImg">
      <van-image
        class="rotationBg"
        :src="require('../assets/images/diagnosis/bg_one.png')"
      />
      <van-image
        class="rotation"
        :src="require('../assets/images/diagnosis/zhizhen.png')"
      />
    </div>
    <div class="inputBg">
      <div class="inputStock">
        <van-row>
          <van-col span="24">
            <van-search
              v-model="search"
              placeholder="代码/名称/简拼"
              @input="handleInput"
              @click="clearInputSearch"
            />
            <van-row v-show="showDropdown" class="droplistStyle">
              <p
                v-for="(item, index) in options"
                :key="index"
                :value="item.short"
                @click="handleClick(item)"
              >
                {{ item.name + " " + item.short }}
              </p>
            </van-row>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <a href="javascript:void(0);" @click="getStockInfo">
              <img
                src="../assets/images/diagnosis/button01.png"
                class="getStockInfo"
              />
            </a>
          </van-col>
        </van-row>
      </div>
    </div>
    <div>
      <img
        style="width: 100%; display: block"
        :src="require('../assets/images/diagnosis/bg_two.png')"
      />
      <img
        style="width: 100%; display: block"
        :src="require('../assets/images/diagnosis/bg_three.png')"
      />

      <img
        style="width: 100%; display: block"
        :src="require('../assets/images/diagnosis/bg_four.png')"
      />
    </div>
    <!-- ========== stock info popup ================ -->
    <van-popup
      v-model="stockInfoStatus"
      :style="{ width: '90%', padding: '15px 0px' }"
    >
      <div class="stockInfoWrapper">
        <van-row>
          <p style="font-size: 14px; text-align: center">智能诊股</p>
        </van-row>
        <van-row style="padding: 10px 0px">
          <van-col span="12" style="border-right: 1px solid #c8c9cc">
            <p class="tName">
              {{ stockInfo.name }}
            </p>
            <p class="tCode">
              {{ stockInfo.code }}
            </p>
          </van-col>
          <van-col span="12">
            <p class="tPrice" :class="activeColor">
              {{ stockInfo.price
              }}<van-icon
                name="down"
                style="transform: rotate(180deg);-ms-transform: rotate(180deg);"
                v-if="activeColor === 'red'"
              ></van-icon
              ><van-icon name="down" v-else></van-icon>
            </p>
            <p class="tChange" :class="activeColor">
              {{ stockInfo.pricechange }} {{ stockInfo.changepercent }}%
            </p>
            <p class="tTime">
              {{ time }}
            </p>
          </van-col>
        </van-row>
        <van-row>
          <van-row
            style="
              border-top: 1px solid #c8c9cc;
              border-bottom: 1px solid #c8c9cc;
            "
          >
            <van-col span="6">
              <div class="stockDynamic">
                <p>今开</p>
                <p>
                  {{ stockInfo.open }}
                </p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="stockDynamic">
                <p>最高</p>
                <p>
                  {{ stockInfo.high }}
                </p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="stockDynamic">
                <p>换手</p>
                <p>{{ stockInfo.changeHands }}%</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="stockDynamic">
                <p>成交量</p>
                <p>{{ Number(stockInfo.volume) / 100 }}万</p>
              </div>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="6">
              <div class="stockDynamic">
                <p>昨收</p>
                <p>
                  {{ stockInfo.settlement }}
                </p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="stockDynamic">
                <p>最低</p>
                <p>
                  {{ stockInfo.low }}
                </p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="stockDynamic">
                <p>振幅</p>
                <p>{{ stockInfo.amplitude }}%</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="stockDynamic">
                <p>成交额</p>
                <p>{{ (Number(stockInfo.amount) / 10000).toFixed(2) }}亿</p>
              </div>
            </van-col>
          </van-row>
        </van-row>
        <van-row>
          <van-col span="24">
            <div class="stockDiagnose">
              <van-row>
                <van-col span="8">
                  <h4 class="right">大数据透视：</h4>
                </van-col>
                <van-col span="16">
                  <p>{{ stockInfo.statement1 }}</p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="8">
                  <h4>短期阻力位：</h4>
                </van-col>
                <van-col span="16">
                  <p>{{ stockInfo.statement2 }}</p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="8">
                  <h4>技术支撑位：</h4>
                </van-col>
                <van-col span="16">
                  <p>{{ stockInfo.statement3 }}</p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="8">
                  <h4>主力动态：</h4>
                </van-col>
                <van-col span="16">
                  <p>{{ stockInfo.statement4 }}</p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="8">
                  <h4>中期趋势：</h4>
                </van-col>
                <van-col span="16">
                  <p>{{ stockInfo.statement5 }}</p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="8">
                  <h4>业绩成长：</h4>
                </van-col>
                <van-col span="16">
                  <p>{{ stockInfo.statement6 }}</p>
                </van-col>
              </van-row>
            </div>
          </van-col>
        </van-row>
        <van-row style="margin: 10px 5px">
          <van-col span="24">
            <p class="control">{{ stockInfo.major_control }}</p>
            <div class="kptype" :class="activeClass"></div>
          </van-col>
        </van-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <van-button type="primary" @click="stockInfoStatus = false"
          >确 定</van-button
        >
      </span>
    </van-popup>
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import CommonLoading from "./CommonLoading";
export default {
  name: "DiagnosisStock",
  components: {
    CommonLoading,
  },
  data() {
    return {
      activeList: [],
      search: "",
      showDropdown: false,
      time: "",
      code: "",
      loading: false,
      state: "",
      options: [],
      stockInfoStatus: false,
      stockInfo: {
        name: "",
        code: "",
        price: "",
        open: "",
        high: "",
        changeHands: "",
        volume: "",
        settlement: "",
        low: "",
        amplitude: "",
        amount: "",
        pricechange: "",
        changepercent: "",
        statement1: "",
        statement2: "",
        statement3: "",
        statement4: "",
        statement5: "",
        statement6: "",
        zlzc: "",
        major_control: "",
        chipPoint: "",
      },
      activeClass: "none",
      activeColor: "red",
    };
  },
  methods: {
    remoteMethod(query) {
      let that = this;
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          let temp = that.dataList.filter((item) => {
            return (
              item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.short.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.pinyin.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
          that.options = temp.slice(0, 50);
        }, 200);
      } else {
        that.options = [];
      }
    },
    getTime() {
      let that = this;
      this.timer = setInterval(function () {
        that.time = that
          .$moment()
          .tz("Asia/Shanghai")
          .format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },
    openDetailed() {
      let that = this;
    },
    loadAll() {
      let that = this;
      that
        .$http({
          url: "/", //请求地址
          method: "post",
          data: {
            nozzle: "all_stock",
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            for (let i = 0, len = resData.data.length; i < len; i++) {
              resData.data[i].value =
                resData.data[i].short +
                " " +
                resData.data[i].name +
                " " +
                resData.data[i].pinyin;
            }
            that.dataList = resData.data;
          } else {
            that.$alert("请稍后尝试", "提示", {
              confirmButtonText: "确定",
              callback: (action) => that.loadAll(),
            });
          }
        });
    },
    getStockInfo() {
      let that = this;
      let stockCode = that.state;
      if (stockCode === "") {
        this.$toast.fail("请输入股票代码");
        return false;
      }
      let url =
        "https://finance.sina.com.cn/tzy/diagnose/" +
        stockCode +
        "/app_public.js";
      $.ajax({
        url: url,
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          that.stockInfo.statement1 = diagnose.statement1;
          that.stockInfo.statement2 = diagnose.statement2;
          that.stockInfo.statement3 = diagnose.statement3;
          that.stockInfo.statement4 = diagnose.statement4;
          that.stockInfo.statement5 = diagnose.statement5;
          that.stockInfo.statement6 = diagnose.statement6;
          that.stockInfo.major_control = diagnose.major_control;
          // that.stockInfo.point_ratio = diagnose.point_ratio;
          that.stockInfo.chipPoint = tech.chipPoint;
          that.stockInfo.zlzc = tech.zlzc;
          that.activeClass = that.zlkp(diagnose.point_ratio);
        },
      });
      that.getNewPrice(stockCode);
      that.stockInfoStatus = true;
      clearInterval(that.chatTimer);
      this.chatTimer = setInterval(function () {
        that.getNewPrice(stockCode);
      }, 1000);
    },

    getNewPrice(stockCode) {
      let that = this;
      $.ajax({
        url: "https://qt.gtimg.cn/q=" + stockCode,
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var elements = eval("v_" + stockCode).split("~");
          that.stockInfo.name = elements[1];
          that.stockInfo.code = stockCode;
          that.stockInfo.price = elements[3];
          that.stockInfo.open = elements[5];
          that.stockInfo.pricechange = elements[31];
          if (elements[31].substr(0, 1) === "-") {
            that.activeColor = "green";
          } else {
            that.activeColor = "red";
          }
          that.stockInfo.changepercent = elements[32];
          that.stockInfo.high = elements[33];
          that.stockInfo.changeHands = elements[38];
          that.stockInfo.volume = elements[36];
          that.stockInfo.settlement = elements[4];
          that.stockInfo.low = elements[34];
          that.stockInfo.amplitude = elements[43];
          that.stockInfo.amount = elements[37];
        },
      });
    },

    zlw(point) {
      if (point < 0) {
        return "dp";
      } else if (point >= 0 && point <= 30) {
        return "dp";
      } else if (point > 30 && point <= 64.48) {
        return "qzc";
      } else if (point > 64.48 && point <= 141.24) {
        return "zd";
      } else if (point > 141.24 && point <= 210) {
        return "qzl";
      } else if (point > 210 && point <= 240) {
        return "tp";
      } else {
        return "tp";
      }
    },
    zlkp(point) {
      if (point < 20) {
        return "none";
      } else if (point >= 20 && point < 60) {
        return "qing";
      } else if (point >= 60 && point < 120) {
        return "zhong";
      } else {
        return "gao";
      }
    },

    handleInput(val) {
      this.remoteMethod(val);
      this.showDropdown = this.options.length > 0;
      this.showDropdown = true;
    },
    handleClick(item) {
      this.search = item.name + " " + item.short;
      this.state = item.short;
      this.showDropdown = false;
    },
    clearInputSearch() {
      this.search = "";
      this.showDropdown = false;
    },
  },
  mounted: function () {
    let that = this;
    that.loadAll();
    that.getTime();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.chatTimer);
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.rotatingImg {
  width: 100%;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rotationBg {
  width: 100%;
  position: relative;
  margin: 0 auto;
}

.rotation {
  margin: auto;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-transform: rotate(360deg);
  animation: rotation 4s linear infinite;
  -moz-animation: rotation 4s linear infinite;
  -webkit-animation: rotation 4s linear infinite;
  -o-animation: rotation 4s linear infinite;
  height: 45%;
  width: 20%;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

.inputBg {
  width: 100%;
  /* height: 120px; */
  background: #ffe7db;
}

.inputStock {
  margin: 0 auto;
  text-align: center;
}

.full_width {
  width: 85%;
}

.full_width >>> input {
  height: 80px;
}

.getStockInfo {
  width: 65%;
  cursor: pointer;
  -webkit-animation: pulse2 1.1s linear infinite both;
  animation: pulse2 1.1s linear infinite both;
  margin: 15px 0px 20px;
}

@keyframes pulse2 {
  0% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
  }

  100% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
}

.zhengu2 {
  width: 100%;
  min-width: 1000px;
  position: relative;
}
.zhengu2 img {
  width: 100%;
}

.btnZhengu {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 125px;
  margin: auto;
  text-align: center;
  width: 25%;
}

.stockInfoWrapper {
  width: 100%;
  text-align: center;
  /* background: url("../assets/images/diagnosis/headcolor.png") no-repeat;
  background-size: contain; */
  background-color: #ffffff;
}

.tName {
  font-size: 22px;
  font-weight: bold;
  margin: 0;
}
.tCode {
  font-size: 20px;
  margin: 0;
}
.tPrice {
  font-size: 22px;
  font-weight: bold;
  margin: 0;
}

.tChange {
  font-size: 14px;
  margin: 0;
}

.tTime {
  margin: 0;
  font-size: 12px;
}

.stockDynamic {
  padding: 5px;
}

.stockDynamic p {
  font-size: 14px;
  color: #333;
  margin: 0px;
}

.stockDiagnose {
  text-align: left;
  margin: 20px 5px 0px;
}
.stockDiagnose h4 {
  text-align: right;
  margin: 0;
  font-size: 14px;
}
.stockDiagnose p {
  margin: 0;
  font-size: 14px;
}

.control {
  margin-top: 20px;
  text-align: left;
  margin: 20px 0px 0px;
  font-size: 14px;
}

.kptype {
  margin: 0 auto;
  margin-top: 30px;
  width: 256px;
  height: 146px;
}

.red {
  color: #ff455e;
}

.green {
  color: #008000;
}

.kptype.none {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png")
    no-repeat -20px -20px;
}

.kptype.qing {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png")
    no-repeat -295px -20px;
}

.kptype.zhong {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png")
    no-repeat -20px -185px;
}

.kptype.gao {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png")
    no-repeat -295px -185px;
}

.zlwtype.dp {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png")
    no-repeat -20px -20px;
}

.zlwtype.qzc {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png")
    no-repeat -306px -20px;
}

.zlwtype.rzc {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png")
    no-repeat -592px -20px;
}

.zlwtype.zd {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png")
    no-repeat -878px -20px;
}

.zlwtype.rzl {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png")
    no-repeat -20px -198px;
}

.zlwtype.qzl {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png")
    no-repeat -306px -198px;
}

.zlwtype.tp {
  background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png")
    no-repeat -592px -198px;
}

.droplistStyle {
  width: 95%;
  max-height: 135px;
  overflow-y: auto;
  background: #ffffff;
  margin: 0 2.5% 0;
  z-index: 2012;
  position: absolute;
  animation-duration: 0.2s;
  transition-duration: 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/components/DiagnosisStock.vue